import React, { useMemo } from 'react';
import { STRINGS, formatCurrency, formatNumber } from '../utils/constants';

const StatMetricCard = ({ label, value, color, sub, span }) => (
  <div className="glass-card stat-metric-card" style={span ? { gridColumn: `span ${span}` } : undefined}>
    <span className="metric-label">{label}</span>
    <span className="metric-value" style={{ color }}>{value}</span>
    {sub && <span className="metric-subtext">{sub}</span>}
  </div>
);

// Renders only the metrics that have meaningful data — keeps the panel honest.
const AdditionalAnalytics = ({ data }) => {
  const metrics = useMemo(() => {
    if (!data) return [];

    const totalRev = data.totalRevenue || 0;
    const items = [];

    if (data.topService) {
      const share = totalRev > 0
        ? Math.round((data.topService.totalRevenue / totalRev) * 100)
        : 0;
      items.push({
        key: 'top',
        label: STRINGS.topSelling,
        value: data.topService.name,
        color: '#10b981',
        sub: `${share}% ${STRINGS.ofSales}`,
      });
    }

    if (data.leastService) {
      const share = totalRev > 0
        ? Math.round((data.leastService.totalRevenue / totalRev) * 100)
        : 0;
      items.push({
        key: 'least',
        label: STRINGS.leastSelling,
        value: data.leastService.name,
        color: '#ef4444',
        sub: `${share}% ${STRINGS.ofSales}`,
      });
    }

    if (data.peakDayName) {
      items.push({
        key: 'peak',
        label: STRINGS.peakDay,
        value: data.peakDayName,
        color: '#3b82f6',
      });
    }

    if (data.avgDailyRevenue > 0) {
      items.push({
        key: 'avgDaily',
        label: STRINGS.avgDailyRev,
        value: formatCurrency(data.avgDailyRevenue),
        color: '#f59e0b',
        sub: STRINGS.perDay,
      });
    }

    return items;
  }, [data]);

  if (metrics.length === 0) return null;

  return (
    <div className="secondary-dashboard-grid mt-4">
      <div className="glass-card chart-card" style={{ gridColumn: '1 / -1' }}>
        <div className="card-title-bar">
          <h3>{STRINGS.additionalAnalytics}</h3>
        </div>
        <div className="stats-panel-grid">
          {metrics.map((m) => (
            <StatMetricCard
              key={m.key}
              label={m.label}
              value={m.value}
              color={m.color}
              sub={m.sub}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdditionalAnalytics;
